<template>
  <section>
    <navigation  :activeTab='"rules"'></navigation>
    <div class="demo-ribbon center-align"></div>
      <main class="demo-main mdl-layout__content">
        <div class="demo-container mdl-grid center-items">
          <div class="demo-content mdl-color--white mdl-shadow--4dp content mdl-color-text--grey-800 mdl-cell mdl-cell--10-col center-items">
            <div class="demo-crumbs mdl-color-text--grey-500">
              KBO Fantasy Baseball &gt; How To Play
            </div>
            <h5>Format</h5>
              <p>
                KBO Fantasy Baseball uses a Rotisserie, or Roto, format. Each team is ranked from first to last in 10 statistical categories totals for an entire season. Points are awarded to each team based on the order in each category. The points earned for each category are combined to determine an overall score and league rank. The categories are as follows: OPS, Runs, HRs, RBI, SBs, Wins, Saves, Ks, ERA and WHIP.
              </p>
            <h5>Transactions</h5>
              <p>
                Rosters are locked for a week at a time (Tuesday through Sunday) as the KBO does not play on Mondays. The league rankings will be updated on a daily basis. Teams will be unlocked on Mondays (Sunday evenings EST) in order to make changes to the team. These changes can be made via the players page ADD player button.
              </p>
            <h5>Drafting</h5>
              <p>
                There is no online draft option. Each team owner will be responsible for inputting their drafted team. Players can be added when the league commissioner "Starts Draft" via their home page. This will prevent other teams from joining the league and each team can add their players. A psuedo-online draft can be accomplished by alternating adding players via team members. It is then the responsibility of the league commissioner to review the submitted rosters, and to "Start League" from their home page. Once the league has started, the season stats will begin to accumulate.
              </p>
            <h5>Minimums</h5>
              <p>
                For the non-counting statistics, like OPS, ERA, and WHIP, there will be a minimum ABs and IPs requirement. General rule of thumb is that the team of 9 batters should average 100-120 ABs combined per week and the 6 pitchers should average around 25 combined innings per week. This is averaged over the course of the entire season, and is not a week to week requirement.
              </p>
            <h5>Questions/Issues</h5>
              <p>
                This site is intended for recreational use only and the results/statistics are not guaranteed in any way. Data will be based on results from <a href="http://www.mykbostats.com">My KBO Stats.</a> Everyone is responsible for ensuring all league members are following the rules. 
              </p>
              <p>
                Please contact <a href="mailto:support@kbofantasybaseball.com">support@kbofantasybaseball.com</a> if there are any questions, comments, suggestions, glitches, etc.! We will do our best to facilitate a fun KBO Fantasy Baseball league for all!
              </p>
              <p>
                See the <router-link to="/tos" tag="a"> Terms of Service </router-link> and <router-link to="/privacy" tag="a"> Privacy Policy </router-link> for additional information.
              </p>
          </div>
        </div>
      </main>
  </section>
</template>

<script>
import navigation from "@/components/NavBar.vue";

 export default {
  data() {
    return {
    }
  },
  components: {
    navigation,
  }

}
</script>
<style >
.demo-ribbon {
  width: 100%;
  height: 40vh;
  background-color: #01579b;
  flex-shrink: 0;
}

.demo-main {
  margin-top: -35vh;
  flex-shrink: 0;
}

.demo-header .mdl-layout__header-row {
  padding-left: 40px;
}

.demo-container {
  max-width: 1600px;
  width: calc(100% - 16px);
  margin: 0 auto;
}

.demo-content {
  border-radius: 2px;
  padding: 80px 56px;
  margin-bottom: 80px;
}

.demo-layout.is-small-screen .demo-content {
  padding: 40px 28px;
}

.demo-content h3 {
  margin-top: 48px;
}

.demo-footer {
  padding-left: 40px;
}

.demo-footer .mdl-mini-footer--link-list a {
  font-size: 13px;
}
</style>


// WEBPACK FOOTER //
// src/components/Rules.vue